import { render, staticRenderFns } from "./xmHeader.vue?vue&type=template&id=07d52a29&scoped=true&"
import script from "./xmHeader.vue?vue&type=script&lang=js&"
export * from "./xmHeader.vue?vue&type=script&lang=js&"
import style0 from "./xmHeader.vue?vue&type=style&index=0&id=07d52a29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d52a29",
  null
  
)

export default component.exports